import { Variant } from '@collaborator/npm_modules/dist/css/variant';
import app from 'srcJs/App';
import { Alert } from 'ui/alert/Alert';
import * as React from 'react';
import { FC } from 'react';

type Props = {
  onClose: () => void,
  onClick: () => void,
};

export const NotifyAlert: FC<Props> = ({ onClose, onClick }) => (
  <Alert variant={Variant.primary} dismissible onClose={onClose}>
    <p className="mb-0">
      {app.t('confirm_email_notifier', '👆Confirm Your Email.')}
      {' '}
      <a href="#" className="text-reset text-underline text-nowrap" onClick={onClick}>
        {app.t('confirm_email_notifier', 'Resend confirmation email.')}
      </a>
    </p>
  </Alert>
);
